module.exports = __webpack_public_path__ + "static/media/page404.b63de51e.png";